module.exports = __webpack_public_path__ + "static/media/logo-iso.97983401.png";